import { styled } from 'theme';

const ToggleButton = styled('button', {
  // Reset
  alignItems: 'center',
  appearance: 'none',
  boxSizing: 'border-box',
  display: 'inline-flex',
  justifyContent: 'center',
  lineHeight: '1',
  outline: 'none',
  padding: '0',
  textDecoration: 'none',
  userSelect: 'none',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  border: 'none',
  fontFamily: 'inherit',
  '&:not(:disabled)': {
    cursor: 'pointer',
  },

  // Custom
  height: '38px',
  px: '$4',
  fontSize: '$sm',
  backgroundColor: 'white',
  color: '$primary',
  borderRadius: '$xs',
  transition: 'all 200ms ease',
  '&:focus': {
    boxShadow: '$focus',
  },
  '&:focus:not(:focus-visible)': {
    boxShadow: 'none',
  },

  variants: {
    isActive: {
      true: {
        backgroundColor: '$violet100',
        fontWeight: '$medium',
      },
    },
  },
});

export default ToggleButton;
